import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { ThemeProvider } from "./context/ThemeContext";
import { AuthProvider } from "./context/AuthContext";
import { queryClient } from "./lib/query-client";
import { ErrorToastProvider } from "./components/ErrorToast";
import { Toaster } from "./components/ui/sonner";
import ErrorBoundary from "./components/ErrorBoundary";

function App() {
  return (
    <ErrorBoundary sectionName="Application">
      <I18nextProvider i18n={i18n}>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider>
            <ErrorToastProvider>
              <AuthProvider>
                <BrowserRouter basename={__BASE_PATH__}>
                  <AppRoutes />
                </BrowserRouter>
              </AuthProvider>
            </ErrorToastProvider>
            <Toaster richColors closeButton position="bottom-right" />
          </ThemeProvider>
        </QueryClientProvider>
      </I18nextProvider>
    </ErrorBoundary>
  );
}

export default App;
